import React from "react";
import { Typography } from "antd";
import { DesktopOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

/**
 * Component displayed to users on mobile/tablet to request desktop access.
 * Replicates the clean, centered design from the uploaded image.
 */
const MobileWarningOverlay = () => {
  // Styles based on the uploaded image design
  const styles = {
    container: {
      width: "100%",
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "#f3f4f7", // Light blueish gray background
      padding: "20px",
    },
    card: {
      maxWidth: "400px",
      padding: "30px",
    },
    iconCircle: {
      width: "100px",
      height: "100px",
      borderRadius: "50%",
      backgroundColor: "#E6F7F7", // Very light teal background for circle
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto 30px",
      border: "1px solid #C9EDEB", // Subtle border
    },
    desktopIcon: {
      fontSize: "48px",
      color: "#00CC99", // Green/Teal icon color
    },
    warningTitle: {
      color: "#4D7EFF", // Bright blue heading color
      fontWeight: 700,
      marginBottom: "20px",
      fontSize: "1.8rem",
      lineHeight: 1.2,
    },
    warningParagraph: {
      color: "#6C757D", // Dark gray body text
      fontSize: "1rem",
      lineHeight: 1.5,
      marginBottom: 0,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Icon Area */}
        <div style={styles.iconCircle}>
          <DesktopOutlined style={styles.desktopIcon} />
        </div>

        {/* Text Content */}
        <Title level={2} style={styles.warningTitle}>
          Please visit us on a desktop
        </Title>
        <Paragraph style={styles.warningParagraph}>
          Our app's features are optimized for a larger screen and a full
          keyboard/mouse experience. We apologize for the inconvenience and hope
          to see you on your desktop soon!
        </Paragraph>
      </div>
    </div>
  );
};

export default MobileWarningOverlay;
